
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusserviceinhadapsar() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Services in Hadapsar',
        heading: 'etravo :  Corporate Cab and Bus Services in Hadapsar',
        headingDescription: 'eTravo provides premium Corporate Cab and Bus Services in Hadapsar, Pune, catering to the growing transportation needs of IT hubs, corporate parks, and industrial zones. Whether your business requires executive cabs for client travel or dedicated buses for employee commutes and team outings, our services are designed for reliability, safety, and comfort. With a fleet of well-maintained vehicles, trained chauffeurs, and real-time GPS tracking, eTravo ensures seamless and professional corporate mobility in and around Hadapsar.',

        top: 'Top Places to Visit in Hadapsar with etravo',
   "topPlaces": [
    {
      "title": "Bhuleshwar Temple",
      "description": "An ancient Shiva temple dating back to the 8th century, Bhuleshwar Temple is renowned for its intricate carvings and unique architecture. Perched atop a hill, it offers panoramic views of the surrounding landscape, making it a serene spot for both devotees and history enthusiasts."
    },
    {
      "title": "Dive Ghat",
      "description": "Dive Ghat is a picturesque mountain pass offering sweeping views of the Sahyadri ranges. It's a popular spot for sunrise and sunset views, and the nearby Mastani Lake adds to its scenic charm."
    },
    {
      "title": "Ramdara Temple",
      "description": "Nestled amidst lush greenery, Ramdara Temple is a tranquil retreat featuring a serene pond and ancient architecture. It's an ideal spot for meditation and nature walks."
    },
    {
      "title": "Mastani Lake",
      "description": "Named after the legendary Mastani, this lake is a peaceful locale surrounded by trees and open spaces. It's perfect for picnics, leisurely walks, and bird watching."
    },
    {
      "title": "Hadapsar Gliding Centre",
      "description": "Operated by the Directorate General of Civil Aviation, this gliding center offers enthusiasts the thrill of non-powered flight. It's one of the few places in India where you can experience gliding."
    },
    {
      "title": "Aditi Garden",
      "description": "Located within the Magarpatta City township, Aditi Garden is a well-maintained urban park featuring walking trails, a variety of plants, and open spaces for relaxation and recreation."
    },
    {
      "title": "Seasons Mall",
      "description": "A premier shopping destination in Hadapsar, Seasons Mall houses a plethora of retail outlets, eateries, and entertainment options, including a multiplex cinema."
    },
    {
      "title": "Fort JadhavGADH",
      "description": "A heritage fort converted into a luxury hotel, Fort JadhavGADH offers a glimpse into Maratha history with its preserved architecture, museum, and cultural programs."
    },
    {
      "title": "Kanifnath Temple",
      "description": "Situated atop a hill, Kanifnath Temple is accessible via a moderate trek. The temple is dedicated to Saint Kanifnath and offers panoramic views of the surrounding countryside."
    },
    {
      "title": "Mayureshwar Wildlife Sanctuary",
      "description": "Located near Baramati, this sanctuary is home to a variety of flora and fauna, including the Indian gazelle. It's a haven for wildlife enthusiasts and photographers."
    }
  ],
    "services": [
    {
      "name": "Corporate Commute Services in Hadapsar",
      "description": "eTravo provides tailored corporate commute services in Hadapsar, catering to businesses of all sizes with efficient and structured transport plans. Whether your company requires daily employee transportation or shift-based movement, we offer a fleet of air-conditioned cabs and buses with real-time tracking. Our services ensure staff punctuality, cost-effectiveness, and an improved employee experience, making us the trusted partner for office transport in Hadapsar."
    },
    {
      "name": "Bus & Cab Hire for Businesses in Hadapsar",
      "description": "eTravo offers flexible bus and cab hire services in Hadapsar for businesses seeking reliable and professional transport. From compact sedans to large corporate buses, our fleet supports everything from daily staff transport to special corporate events. With trained drivers, scheduled pickups, and safety protocols, our business transport rentals are designed for comfort and efficiency at competitive rates."
    },
    {
      "name": "Employee Transportation Hadapsar",
      "description": "Streamline your employee transportation in Hadapsar with eTravo’s fully managed service. We help companies reduce absenteeism and improve on-time attendance by offering safe, comfortable, and punctual transport for staff. Our employee commute services include route planning, shift management, and 24/7 support, ensuring reliable mobility every day, even during peak industrial hours."
    },
    {
      "name": "Office Shuttle Services Hadapsar",
      "description": "eTravo’s office shuttle services in Hadapsar are ideal for companies operating in tech parks, manufacturing units, and industrial estates. Our shuttles follow fixed or flexible routes based on your company’s needs and offer dedicated services. All shuttles are GPS-enabled, regularly sanitized, and driven by experienced professionals for a smooth and secure daily commute."
    },
    {
      "name": "Daily Commute Cabs for Companies in Hadapsar",
      "description": "eTravo provides reliable daily commute cabs for companies in Hadapsar, offering a stress-free travel experience for your employees. Whether your requirement is for a handful of staff or large groups, our cab services are designed to align with your team’s work schedules and pickup zones. Book hourly, daily, or long-term services with transparent pricing and dedicated account management."
    },
    {
      "name": "Corporate Bus Rental Hadapsar",
      "description": "For companies in Hadapsar needing large-scale transport, eTravo offers dependable corporate bus rental services. Our fleet includes 20–50 seater AC buses perfect for factory shifts, office commutes, training programs, or corporate gatherings. We ensure vehicle availability, timely dispatches, and dedicated support, making us the preferred partner for high-volume staff transportation."
    },
    {
      "name": "Budget Cab Hire for Corporate Needs Hadapsar",
      "description": "Looking for affordable yet reliable transport for your staff? eTravo’s budget cab hire services in Hadapsar are perfect for startups, SMEs, and growing companies. We offer clean, air-conditioned cabs with experienced drivers and flexible routes. From daily staff pick-ups to executive visits, our budget cab solutions deliver quality and convenience at a reasonable price."
    }
  ],
  "tableData": [
    ["Corporate Commute Services in Hadapsar", "Bus & Cab Hire for Businesses in Hadapsar"],
    ["Employee Transportation Hadapsar", "Office Shuttle Services Hadapsar"],
    ["Daily Commute Cabs for Companies in Hadapsar", "Corporate Bus Rental Hadapsar"],
    ["Budget Cab Hire for Corporate Needs Hadapsar", ""]
  ],






"whychoose": [
    {
        "WhyChooseheading": "Punctual and Hassle-Free Transport in Hadapsar",
        "WhyChoosedescription": "Hadapsar is one of Pune’s fastest-growing commercial hubs, and timely employee transportation is essential to maintain productivity. eTravo’s corporate cab and bus services in Hadapsar are designed to ensure reliable, on-time travel for employees, clients, and corporate guests—minimizing late arrivals and maximizing workplace efficiency."
    },
    {
        "WhyChooseheading": "Versatile Fleet for Every Corporate Requirement",
        "WhyChoosedescription": "From executive sedans for management and client meetings to large AC buses for daily staff shuttles, eTravo provides a full fleet of modern, comfortable vehicles in Hadapsar. Each vehicle is spacious, well-maintained, and equipped with air conditioning, cushioned seating, and luggage space to ensure a relaxed commute."
    },
    {
        "WhyChooseheading": "Professional Drivers with Local Expertise",
        "WhyChoosedescription": "Our drivers are not just trained and verified—they’re also familiar with Hadapsar’s IT parks, commercial complexes, and industrial zones. Whether it’s navigating traffic around Magarpatta City, Fursungi IT Park, or SP Infocity, our team ensures smooth, respectful, and efficient travel for your staff and visitors."
    },
    {
        "WhyChooseheading": "Transparent Pricing That Fits Your Budget",
        "WhyChoosedescription": "eTravo offers competitive and transparent pricing for all corporate cab and bus services in Hadapsar. With no hidden fees and customized billing options, we make it easy for companies to plan and scale their transport operations without overspending or compromising on quality."
    },
    {
        "WhyChooseheading": "Safety-Focused Transport You Can Trust",
        "WhyChoosedescription": "We put passenger safety first. All vehicles are equipped with GPS tracking, seat belts, first-aid kits, fire extinguishers, and undergo regular maintenance. Our vehicles are also sanitized frequently to meet hygiene standards—ensuring that your employees commute in a safe and secure environment."
    },
    {
        "WhyChooseheading": "24/7 Service to Match Your Business Schedule",
        "WhyChoosedescription": "With Hadapsar’s business zones operating on flexible hours, eTravo provides 24/7 service and support. Whether your company runs night shifts, weekend operations, or needs last-minute transfers, our team is always on standby to deliver dependable corporate travel at any time."
    },
    {
        "WhyChooseheading": "Easy Booking and Route Management",
        "WhyChoosedescription": "eTravo’s smart booking platform lets you schedule, modify, and track corporate rides effortlessly. HR teams and office admins in Hadapsar can monitor transport status in real-time and adjust routes based on employee needs—ensuring smooth coordination with minimal manual effort."
    },
    {
        "WhyChooseheading": "Tailored Transport Solutions for Hadapsar-Based Businesses",
        "WhyChoosedescription": "Whether you're an IT company, manufacturing unit, or service firm, eTravo provides fully customized cab and bus solutions for your unique requirements in Hadapsar. From daily staff transportation to client pick-up and outstation business travel—we create flexible, end-to-end travel plans that scale with your business."
    }
]

























    }


   
// Corporate Cab and Bus Services in Hadapsar – eTravo

const faqData = [
    [
        {
            question: 'What corporate transportation services does eTravo offer in Hadapsar?',
            answer: 'eTravo provides end-to-end corporate cab and bus services in Hadapsar, including employee transportation, executive cab services, event logistics, and customized shift-based travel solutions.',
        },
        {
            question: 'Can eTravo manage daily employee commute services for companies in Hadapsar?',
            answer: 'Yes, we offer structured employee transportation with well-defined pickup and drop routes, tailored to your company’s shift timings and team sizes using both cabs and buses.',
        },
        {
            question: 'What vehicle options are available for corporate clients in Hadapsar?',
            answer: 'Our fleet includes sedans, hatchbacks, SUVs for executives, as well as AC buses and tempo travellers for large teams — all professionally maintained and operated by trained drivers.',
        },
        {
            question: 'Does eTravo provide safety tracking and monitoring for daily transport?',
            answer: 'Absolutely. All eTravo vehicles are GPS-enabled, and we provide live tracking, driver verification, and automated reports to ensure secure and efficient corporate transport operations.',
        },
        {
            question: 'Is outstation or inter-branch travel available from Hadapsar for business purposes?',
            answer: 'Yes, we offer outstation and intercity cab and bus bookings for corporate travel, including site visits, audits, and meetings, with full coordination and itinerary support.',
        },
        {
            question: 'Do you offer dedicated account management for corporate clients in Hadapsar?',
            answer: 'Yes, every corporate client is assigned a dedicated account manager for day-to-day coordination, reporting, issue resolution, and service optimization.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Saurabh Phadke',
        designation: 'Admin Manager, Infomind Systems',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s cab and bus service in Hadapsar is reliable and well-organized. Our employees are happy with the punctuality, vehicle quality, and the responsive support team.”',
    },
    {
        name: 'Ms. Richa Nene',
        designation: 'HR Executive, Maxlinx Solutions',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve used eTravo for over a year now. Their corporate transport in Hadapsar is always on time, professionally handled, and very well suited for tech parks and industrial zones.”',
    },
];






















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Hadapsar",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-hadapsar.jpg",
  "description": "Book reliable corporate cab and bus services in Hadapsar with eTravo for employee transportation, office shuttle, and daily business commute. Affordable and professional AC cabs and buses tailored for corporate needs.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5657"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2299",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-hadapsar"
  }
};




    return (
        <div>

<Helmet>
  <title>Corporate Cab and Bus Services in Hadapsar | Staff Transport & Office Shuttle | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Hadapsar with eTravo for office shuttle, employee transport, and daily corporate commute. Affordable and reliable AC vehicles with professional drivers." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/11.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusserviceinhadapsar;